import React from 'react';
import PropTypes from 'prop-types';
import mixin from 'react-mixin';
import ActionButton from '../action/action_button.jsx';
import { FormAPI, FlashMessageAPI } from 'lecom-api';
import { event } from 'jquery';

const RealizeFlash = window.Flash;

@mixin.decorate(window.CssClassMixin)
export default class FormActionsGroup extends React.Component {
	static propTypes = {
		inputs: PropTypes.array,
		submitButton: PropTypes.object,
		actions: PropTypes.array,
		isLoading: PropTypes.bool,
		isMobile: PropTypes.bool,
	};

	static defaultProps = {
		themeClassKey: 'form.buttonGroup',
		inputs: [],
		submitButton: {
			name: 'button.send',
			icon: 'send'
		},
		actions: [],
		isLoading: false,
		isMobile: false,
		allInputsHidden: false,
	};

	state = {
		disableSpecificActions: false,
	}

	componentDidMount() {
		this.tabOrder();
		window.addEventListener('message', this.handlePostMessage);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.handlePostMessage);
	}

	handlePostMessage = ({ data: { event: eventType, actionName } = {} }) => {
		if (eventType === 'ACTION_HEADER' && actionName === 'saveActivity') {
			this.setState({ disableSpecificActions: true });
		}

		if (eventType === 'SAVE_FORM_SUCCESS' || eventType === 'SAVE_FORM_ERROR') {
			this.setState({ disableSpecificActions: false });
		}
	};

	tabOrder() {
		let actions = this.props.actions;

		if (actions.length > 0) {
			let actionsName = actions.map(n => n.name);

			for (var x = 0; x < actionsName.length; x++) {
				let name = actionsName[x];

				if ($(`.${name}`).is(':visible') === true) {
					$(`.${name}`)[0].setAttribute('tabindex', '0');
				}
			}
		}
	}

	areAllInputsHidden() {
		const inputs = this.props.inputs;
		let allHidden = true;

		for (let field in inputs) {
			const input = inputs[field];

			if (input.type === "GRID") {
				let formApi = FormAPI.form(input.formId);
				let field = formApi ? formApi.fields(input.id) : null;

				if (field && field.visible()) {
					allHidden = false;
					break;
				}
			}
			else {
				if (input.visible) {
					allHidden = false;
					break;
				}
			}
		}

		return allHidden;
	}

	renderActions() {
		if (!this.props.actions.length) return '';

		return this.props.actions
			.filter((actionProps) => {
				if (this.props.isMobile) {
					return actionProps.type !== 'link' && !actionProps.hidden;
				}

				return !actionProps.hidden;
			})
			.map((actionProps, index) => {
				const actionsToDisable = ['aprovar', 'cancel', 'rejeitar', 'finish'];

				const shouldDisable =
					this.props.isLoading ||
					(this.state.disableSpecificActions && actionsToDisable.includes(actionProps.name));

				return (
					<ActionButton
						disabled={shouldDisable}
						{...actionProps}
						element="a"
						key={"form_action__" + index}
						className={actionProps.name}
					/>
				);
			});
	}

	render() {
		let messageContent =
			window?.Realize?.i18n?.t?.('form.errors.are_all_inputs_hidden') ||
			'Há campos ocultos no formulário.';
		if (this.areAllInputsHidden()) {
			FlashMessageAPI.flash().addMessageIfNotExists({ message: messageContent, type: 'warning', canDismiss: false });
		} else {
			FlashMessageAPI.flash().removeMessageByContent(messageContent);
		}

		return (
			<div className={!this.props.isMobile ? this.className() : `${this.className()} mobile`}>
				{this.renderActions()}
			</div>
		);
	}
}